
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/configuracion.vue';
    import movil from './pc/configuracion.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {



    }
